import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from 'app/shared/shared.module';

import { SiteLogoRestConnectorService } from './services/site-logo-rest-connector.service';
import { SiteLogoService } from './services/site-logo.service';
import { SiteLogoEffects } from './state/site-logo-effects';
import { siteLogoReducer } from './state/site-logo-reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('siteLogo', siteLogoReducer),
    EffectsModule.forFeature([
      SiteLogoEffects,
    ]),
    CommonModule,
    SharedModule,
  ],
  providers: [
    SiteLogoService,
    SiteLogoRestConnectorService,
    SiteLogoEffects,
  ],
})
export class SiteLogoModule { }
